import { memo } from 'react';
import { ProductTotals } from './ProductTotals';
import { StaticSubscriptionProduct } from './StaticSubscriptionProduct';
import { SubscriptionProductItem } from '../../../utils/subscriptionDetail/types';
import { QuantityUpdate } from '../../../hooks/use-product-cart';
import styles from '../../../assets/scss/SubscriptionDetail/NextDeliverySubscription/SubscriptionProduct.module.scss';

type Props = {
  column: number;
  product: SubscriptionProductItem;
  quantity: number;
  changeQuantity: (updates: QuantityUpdate | QuantityUpdate[]) => void;
  onClickProductLink: (p: SubscriptionProductItem) => void;
};

export const SubscriptionProduct = memo(function SubscriptionProduct({
  column,
  product,
  quantity,
  changeQuantity,
  onClickProductLink,
}: Props) {
  const columnClass = column === 1 ? styles.column1 : styles.column2;

  return (
    <div className={`${styles.product} ${columnClass}`}>
      {/* 画像、タイトル、割引率、値段 */}
      <StaticSubscriptionProduct
        column={column}
        product={product}
        onClickProductLink={onClickProductLink}
      />

      <ProductTotals
        column={column}
        product={product}
        quantity={quantity}
        changeQuantity={changeQuantity}
      />

      {/* 特別文言 */}
      {product.specialMsg && (
        <div
          className={styles.specialMsg}
          dangerouslySetInnerHTML={{ __html: product.specialMsg }}
        />
      )}
    </div>
  );
});
